import React from "react";
import { ArrowLeft, Check } from "lucide-react";

const TIPS = [
  "Utilizza una luce uniforme e frontale",
  "Preferibilmente luce naturale indiretta",
  "Evita il controluce",
  "Pulisci la lente della fotocamera",
  "Rimuovi gli occhiali",
  "Tieni i capelli lontani dal viso",
  "Mantieni un'espressione neutra",
  "Evita filtri e modalità bellezza",
  "Se possibile, effettua il test senza trucco coprente",
];

export default function Prep({ onReady, onBack }) {
  return (
    <div className="fs-container py-8 fs-fade-up">
      <button onClick={onBack} className="flex items-center gap-1.5 text-sm text-[var(--fs-ink-2)] mb-6 fs-focus rounded" data-testid="prep-back-button">
        <ArrowLeft size={16} /> Indietro
      </button>

      <span className="fs-eyebrow">Preparazione</span>
      <h1 className="text-2xl font-bold mt-2">Per un risultato più coerente</h1>

      <div className="mt-6 fs-card p-5">
        <ul className="space-y-3">
          {TIPS.map((t, i) => (
            <li key={i} className="flex items-start gap-3" data-testid={`prep-tip-${i}`}>
              <span className="grid place-items-center w-6 h-6 rounded-full bg-[var(--fs-tint)] text-[var(--fs-blue)] shrink-0 mt-0.5">
                <Check size={14} strokeWidth={3} />
              </span>
              <span className="text-sm text-[var(--fs-ink)]">{t}</span>
            </li>
          ))}
        </ul>
      </div>

      <p className="mt-5 text-sm text-[var(--fs-ink-2)]">Una buona fotografia rende l'analisi più attendibile.</p>

      <button onClick={onReady} className="fs-btn-primary w-full py-4 mt-7 fs-focus" data-testid="prep-ready-button">
        SONO PRONTA/O
      </button>
    </div>
  );
}
